import {DailyTimesheetReport} from "./DailyTimesheetReport.js";

export class WeeklyTimesheetReport {
    startOfWeek = new Date();
    endOfWeek = new Date();
    billable = 0;
    notBillable = 0;
    plannedBillable = 0;
    plannedNotBillable =0;
    /**
     * @type {Map<number, {weekDay: {index:number,label:string,date:Date}, billable:0, notBillable: 0, plannedBillable: 0, plannedNotBillable:0, perCustomer: Map<string,{billable:number,notBillable:number}>,byCustomerMap:Map}>}
     */
    durationMap = new Map();
}